// src/firebase/firebase.js

import { initializeApp } from 'firebase/app';
import { collection, getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const env = process.env.REACT_APP_ENV;

const firebaseProdConfig = {
    apiKey: "AIzaSyDB8xqPWpTdphXSrhzcrZ6A4LJpTHe9HJg",
    authDomain: "driver-app-7505a.firebaseapp.com",
    projectId: "driver-app-7505a",
    storageBucket: "driver-app-7505a.appspot.com",
    messagingSenderId: "853727058025",
    appId: "1:853727058025:web:72f989d8bee91fb4f16af8",
    measurementId: "G-H05CQJGSL7"
};

const firebaseDevConfig = {
    apiKey: "AIzaSyBtz-b0Xg9Hre7ppMkNa8XRIFEDvyoTKFg",
    authDomain: "harbourcabs-dev.firebaseapp.com",
    projectId: "harbourcabs-dev",
    storageBucket: "harbourcabs-dev.appspot.com",
    messagingSenderId: "576075458433",
    appId: "1:576075458433:web:ab8719edf51ba46b63ea80",
    measurementId: "G-EMPS1NHHZG"
};

const projectConfig = env === "dev" ? firebaseDevConfig : firebaseProdConfig;
console.log('env================>: ', env);

// Initialize Firebase
const app = initializeApp(projectConfig);

// Initialize Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firebase Storage and get a reference to the service
export const storage = getStorage(app);

// Initialize Firebase Functions and get a reference to the service
export const functions = getFunctions(app);

// Firestore collection references
export const complaints = collection(db, 'complaints');

export const refs = {
    complaints
};